<div class="filter" [ngClass]="{'--theme-unico': theme === 'unico'}">
  <div class="filter__content">
    <div class="filter__container">
      <up-feature-filter-search
        *ngIf="!isRescueScreen"
        class="filter__search"
        (item)="selectUnits($event)"
        title="Filiais"
        [filters]="units$"
        [theme]="theme">
      </up-feature-filter-search>
      <up-feature-filter-search
        class="filter__search"
        (item)="selectDepartments($event)"
        title="Departamentos"
        [filters]="departments$"
        [theme]="theme">
      </up-feature-filter-search>
      <up-feature-filter-search
        class="filter__search"
        (item)="selectRoles($event)"
        title="Cargos"
        [filters]="roles$"
        [theme]="theme">
      </up-feature-filter-search>
    </div>
    <div *ngIf="!isCollaboratorModule" class="export" (click)="clickInside($event)">
      <button type="button" (click)="toggleDropDown()" class="export__button" aria-label="Abrir menu de exportação" data-test="listExportAdmission"></button>
      <ul class="export__menu" *ngIf="menuExport">
        <li>
          <button class="export-list" type="button" (click)="exportSummary()" data-test="btnExportReport">Exportar listagem</button>
        </li>
        <li>
          <button class="export-payroll" type="button" (click)="exportData()" data-test="btnExportPayrool">Exportar para folha</button>
        </li>
      </ul>
    </div>
  </div>
</div>
